var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.378,
    height: 100.23,
    viewBox: "0 0 88.378 100.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.811 -26.143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.854,116.354,19.811,26.143h88.378l-8.051,90.2L63.946,126.373Z",
    fill: "#e44d26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,118.7,93.244,110.6l6.881-77.076H64Z",
    fill: "#f16529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,66.978H49.359l-1.01-11.331H64V44.583H36.257l.264,2.969,2.72,30.489H64Zm0,28.733-.049.013L51.63,92.4l-.788-8.823H39.735l1.55,17.372,22.664,6.292.051-.015Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.962,66.978V78.041H77.586L76.3,92.39l-12.34,3.331v11.51l22.682-6.286.166-1.87,2.6-29.127.27-2.97H63.962Zm0-22.395V55.647H90.687l.221-2.487.5-5.608.265-2.969Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.dd6f9394aae0b816e60c8cb213c388e1.svg";
export { ForwardRef as ReactComponent };